<template>
  <el-dialog
    :title="userData && userData.id ? '编辑用户' : '添加用户'"
    :model-value="value"
    width="50%"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="userForm" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="姓名" prop="user_name">
        <el-input v-model="form.user_name" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="旗县" prop="department_id">
        <el-select
          v-model="form.department_id"
          placeholder="请选择旗县"
          style="width: 100%"
        >
          <el-option
            v-for="dept in departmentList"
            :key="dept.id"
            :label="dept.name"
            :value="dept.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="请输入邮箱" />
      </el-form-item>
      <el-form-item v-if="isSuperAdmin" label="用户类型" prop="user_type">
        <el-select
          v-model="form.user_type"
          placeholder="请选择用户类型"
          style="width: 100%"
        >
          <el-option :value="1" label="超级管理员" />
          <el-option :value="2" label="旗县管理员" />
          <el-option :value="3" label="普通用户" />
        </el-select>
      </el-form-item>
      <!-- 只有超管能指派。服务端同样只在超管身份下才接这个字段（见 sso/controllers/user.go），
           藏起输入框不是闸门，只是少给个误操作的机会。 -->
      <el-form-item v-if="isSuperAdmin" label="知识库负责人">
        <el-checkbox v-model="form.is_knowledge_owner">可上传 / 改名 / 删除中心知识库文档</el-checkbox>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="$emit('input', false)">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  
  <script>
import { getDepartments } from "@/api/user-management/department";

export default {
  name: "UserDialog",
  props: {
    value: Boolean,
    userData: Object,
  },
  data() {
    return {
      departmentList: [], // 旗县列表数据
      form: {
        user_name: "",
        department_id: "",
        phone: "",
        email: "",
        user_type: 3, // 默认普通用户
        is_knowledge_owner: false,
      },
      rules: {
        user_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        department_id: [
          { required: true, message: "请选择旗县", trigger: "change" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的11位中国大陆手机号",
            trigger: ["blur", "change"],
          },
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        user_type: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    isSuperAdmin() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
      return userInfo.user_type === 1;
    },
  },
  watch: {
    userData: {
      immediate: true,
      handler(val) {
        console.log("userData", val);
        if (val && val.id) {
          this.form = {
            ...val,
            department_id: val.department?.id,
            // 列表接口没回这个字段时也要是确定的 false，不能是 undefined ——
            // 否则 el-checkbox 的初值不稳定，提交时还会把 undefined 发出去
            is_knowledge_owner: val.is_knowledge_owner === true,
          };
        } else if (val && val.department_id) {
          this.form = {
            user_name: "",
            department_id: val.department_id,
            phone: "",
            email: "",
            user_type: 3, // 默认普通用户
            is_knowledge_owner: false,
          };
        } else {
          this.form = {
            user_name: "",
            department_id: "",
            phone: "",
            email: "",
            user_type: 3, // 默认普通用户
            is_knowledge_owner: false,
          };
        }
      },
    },
    value(newVal, oldVal) {
      // 只在对话框从关闭状态变为打开状态时获取部门列表
      if (newVal && !oldVal) {
        this.fetchDepartments();
      }
    },
  },
  created() {
    // 组件创建时获取一次部门列表
    this.fetchDepartments();
  },
  methods: {
    // 获取旗县列表
    async fetchDepartments() {
      try {
        const res = await getDepartments({ page: 1, size: 1000 });
        this.departmentList = res.data.rows;
      } catch (error) {
        console.error("获取旗县列表失败:", error);
      }
    },

    handleClose() {
      this.$refs.userForm.resetFields();
    },
    async handleSubmit() {
      try {
        const valid = await this.$refs.userForm.validate();
        if (!valid) return;

        const userData = {
          ...this.form,
        };

        if (this.userData.id) {
          // 编辑用户
          await this.$emit("updateUser", userData);
        } else {
          // 添加用户
          await this.$emit("createUser", userData);
        }
      } catch (error) {
        console.error("操作失败:", error);
        this.$message.error(error.message || "操作失败");
      }
    },
  },
};
</script>
